import ReferralContextService from '_services/Referral/ReferralContextService';
import ReferralAttributionService from '_services/Referral/ReferralAttributionService';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useLocation, useRoutes } from 'react-router-dom';

import commonRoutes from './Common/routes';
import guestRoutes from './Guest/routes';
import protectedRoutes from './Protected/routes';

export const isUrlProtected = (location: string): boolean => {
    const guestRoutesChild = [
        ...(guestRoutes?.children ?? []),
        ...(commonRoutes.children ?? []),
    ];

    for (let index = 0; index < guestRoutesChild.length; index++) {
        const { path } = guestRoutesChild[index];
        if (path && location.includes(path)) {
            return false;
        }
    }

    return true;
};

const Router = (): React.ReactElement | null => {
    const location = useLocation();
    const [referralCaptureKey, setReferralCaptureKey] = useState<string | null>(
        null,
    );
    const referralUuidFromSearch = ReferralContextService.getUuidFromSearch(
        location.search,
    );
    const currentReferralUuid = ReferralContextService.peekUuid();
    const pendingReferralCapture =
        referralUuidFromSearch !== null &&
        referralUuidFromSearch !== currentReferralUuid &&
        referralCaptureKey !== location.key;

    useLayoutEffect(() => {
        if (!pendingReferralCapture || !referralUuidFromSearch) {
            return;
        }

        ReferralContextService.setUuid(referralUuidFromSearch);
        setReferralCaptureKey(location.key);
    }, [
        location.key,
        pendingReferralCapture,
        referralUuidFromSearch,
        setReferralCaptureKey,
    ]);

    useEffect(() => {
        void ReferralAttributionService.trackAppEntry();
    }, [location.search]);

    const routes = useRoutes([guestRoutes, protectedRoutes, commonRoutes]);

    if (pendingReferralCapture) {
        return null;
    }

    return routes;
};

export default Router;
